// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"qe_a bhr_sn bhr_va","ForumSearch__img":"qe_b","ForumSearch__searchAdsAndShoppingAds":"qe_c","ForumSearch__results--empty":"qe_e"};